import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import { numberWithCommas } from '../../../common/util/NumberUtils';
import { commonEchartsTooltipFormatter } from '../../../common/util/CommonEcharts.util';

export interface CompareAssetCardBarChartData {
  savingChangeAmount: number;
  investmentChangeAmount: number;
  etcChangeAmount: number;
}

const CompareAssetCardBarChart = ({
  savingChangeAmount,
  investmentChangeAmount,
  etcChangeAmount,
}: CompareAssetCardBarChartData) => {
  const elementId = `compare-chart-${ Math.floor(Math.random() * 1000000000)}`;
  useEffect(() => {
    // 전월 비교 차트
    const compareChartDom = document.getElementById(elementId);
    if (compareChartDom) {
      const compareChart = echarts.init(compareChartDom);
      const compareOption = {
        animation: false,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: commonEchartsTooltipFormatter,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: ['저축', '투자', '기타'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '증감액',
            type: 'bar',
            data: [savingChangeAmount, investmentChangeAmount, etcChangeAmount],
            itemStyle: {
              color: function (params: any) {
                return params.data >= 0 ? '#4CAF50' : '#F44336';
              },
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params: any) => {
                return `${numberWithCommas(params.data)}원`;
              },
            },
          },
        ],
      };
      compareChart.setOption(compareOption);
      window.addEventListener('resize', () => {
        compareChart.resize();
      });
    }
  }, [savingChangeAmount, investmentChangeAmount, etcChangeAmount]);

  return <div id={elementId} className="w-full h-72 mb-6"></div>;
};

export default CompareAssetCardBarChart;
